import React from 'react';
import {useWindowDimensions, View} from 'react-native';

import {FilterButton} from '/component/base/SectionHeader/component';
import Text from '/component/base/Text';
import Gutter from '/component/layout/Gutter';
import {Reports} from '/constant/TestIDs';
import {getTextFromReactNode} from '/util/accessibility.util';

import KeyboardFocusable from '../ExtKeyboard/KeyboardFocusable';

import {SortButton} from './component';
import {styles} from './SectionHeader.style';

export const SectionHeader = ({
  children,
  style: styleProp = {},
  reportName = '',
  reportIsLoading = true,
  reportMeta = {},
  loadingData = {},
  tierName = '',
  isViewTeam = '',
  allowFontScaling = true,
  maxFontSizeMultiplier = 2,
}: any) => {
  const {fontScale} = useWindowDimensions();
  const isLargeFontScale = fontScale > 1.2;
  const style = [styles.base, styleProp.base];

  const textStyle = [styleProp.text || {}, tierName && styles.report];
  const containerStyle = [
    tierName ? styles.containerReport : styles.container,
    isLargeFontScale &&
      (tierName ? styles.containerReportWrapped : styles.containerWrapped),
  ];
  const titleContainerStyle = [
    styles.titleContainer,
    isLargeFontScale && styles.titleContainerWrapped,
    ...textStyle,
  ];
  const filterSortStyle = [
    styles.filterSort,
    isLargeFontScale && styles.filterSortWrapped,
  ];

  return (
    <View style={style}>
      <Gutter style={containerStyle}>
        <KeyboardFocusable
          style={titleContainerStyle}
          accessible={true}
          accessibilityLabel={getTextFromReactNode(children)}>
          <Text
            accessible={false}
            allowFontScaling={allowFontScaling}
            maxFontSizeMultiplier={maxFontSizeMultiplier}
            accessibilityLabel={
              typeof children === 'string'
                ? children
                : React.Children.toArray(children)
                    .map(child =>
                      typeof child === 'string'
                        ? child
                        : child?.props?.children || '',
                    )
                    .join(' ')
            }
            emphasis="low"
            variant="subheading"
            testID={Reports.reportClientsSectionTitle}>
            {children}
          </Text>
        </KeyboardFocusable>
        <View style={filterSortStyle}>
          {tierName && (
            <FilterButton
              recordsName={reportName}
              reportIsLoading={reportIsLoading}
              reportMeta={reportMeta}
              loadingData={loadingData}
              tierName={tierName}
            />
          )}
          <SortButton
            isViewTeam={isViewTeam}
            recordsName={reportName}
            reportIsLoading={reportIsLoading}
            reportMeta={reportMeta}
            loadingData={loadingData}
            tierName={tierName}
          />
        </View>
      </Gutter>
    </View>
  );
};

export default SectionHeader;
